/* AUVENNE V3 commerce fixes — category swatches + useful drawer recommendations. */
(function(){
  'use strict';
  if(window.AUVENNEV3CommerceFixesBound)return;
  window.AUVENNEV3CommerceFixesBound=true;

  var isSv=(document.documentElement.lang||'').toLowerCase().indexOf('sv')===0;
  function ui(nl,sv){return isSv?sv:nl;}
  function rootPath(){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';return r.charAt(r.length-1)==='/'?r:r+'/';}
  function money(cents){var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||(isSv?'SEK':'EUR');try{return new Intl.NumberFormat(isSv?'sv-SE':'nl-NL',{style:'currency',currency:cur,maximumFractionDigits:cur==='SEK'?0:2}).format((Number(cents)||0)/100);}catch(e){return String((Number(cents)||0)/100);}}

  function applyCardSwatch(button){
    var card=button&&button.closest('[data-cro-card]');
    if(!card||button.disabled)return;
    card.querySelectorAll('[data-cro-card-swatch]').forEach(function(item){item.setAttribute('aria-pressed',item===button?'true':'false');});
    card.dataset.auvSelectedColour=button.getAttribute('data-colour-value')||'';
    var label=card.querySelector('[data-cro-card-swatch-label]');
    if(label)label.textContent=button.getAttribute('data-label')||'';

    var primary=card.querySelector('.cro-card__image > img:not(.cro-card__second)');
    var image=button.getAttribute('data-image');
    if(primary&&image){
      if(!primary.dataset.auvOriginalSrc)primary.dataset.auvOriginalSrc=primary.currentSrc||primary.src||'';
      primary.src=image;
      primary.removeAttribute('srcset');
    }

    var direct=card.querySelector('[data-cro-card-variant]');
    var variantId=button.getAttribute('data-variant-id');
    if(card.getAttribute('data-product-handle')==='legame-knot-cuff'){
      card.querySelectorAll('a.cro-card__image,a.cro-card__title').forEach(function(link){
        var url=new URL(link.href,location.href);url.searchParams.set('variant',button.getAttribute('data-variant-id'));link.href=url.toString();
      });
      var alternate=card.querySelector('.cro-card__second');if(alternate){alternate.hidden=true;alternate.style.display='none';}
    }
    if(direct&&variantId)direct.value=variantId;

    var select=card.querySelector('[data-cro-card-variant-select]');
    if(select){
      var colour=button.getAttribute('data-colour-value')||'';
      Array.prototype.forEach.call(select.options,function(option){
        if(!option.value){option.hidden=false;return;}
        var optionColour=option.getAttribute('data-colour-value')||'';
        option.hidden=!!colour&&!!optionColour&&optionColour!==colour;
      });
      select.value='';
      var status=card.querySelector('[data-cro-status]');if(status)status.textContent='';
    }
  }

  function initCardSwatches(scope){
    (scope||document).querySelectorAll('[data-cro-card]').forEach(function(card){
      if(card.dataset.auvV3Swatches==='1')return;
      card.dataset.auvV3Swatches='1';
      var active=card.querySelector('[data-cro-card-swatch][aria-pressed="true"]')||card.querySelector('[data-cro-card-swatch]');
      if(active)applyCardSwatch(active);
    });
  }

  document.addEventListener('click',function(event){
    var swatch=event.target.closest('[data-cro-card-swatch]');
    if(!swatch)return;
    event.preventDefault();
    event.stopPropagation();
    applyCardSwatch(swatch);
  },true);

  var recHandles=[
    'legame-knooparmband','promessa-oval-ring','luce-parel-oorbellen','fortuna-clover-necklace',
    'ovale-fijne-schakelarmband','mira-beaded-ring','perla-huggie-hoops','legame-knot-cuff',
    'abbraccio-knuffelring','cascata-beaded-y-necklace','nodo-parel-oorbellen','insieme-ring-set'
  ];
  var productCache={};
  var recTimer=0;
  var drawerCheckTimer=0;

  function cartJson(){return fetch(rootPath()+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error('cart');return r.json();});}
  function loadProduct(handle){if(productCache[handle])return productCache[handle];productCache[handle]=fetch(rootPath()+'products/'+handle+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});return productCache[handle];}
  function eligibleQuantity(cart){var state=window.AUVENNEAudit&&typeof window.AUVENNEAudit.cartState==='function'?window.AUVENNEAudit.cartState(cart):null;if(state&&Number.isFinite(Number(state.quantity)))return Number(state.quantity);return Number(cart&&cart.item_count)||0;}
  function firstAvailable(product){return product&&Array.isArray(product.variants)?product.variants.find(function(v){return v.available;})||null:null;}

  function recommendationPanel(entries,qty){
    var wrap=document.createElement('section');
    wrap.className='auv-third';
    wrap.setAttribute('data-auv-third-suggestions','');
    wrap.setAttribute('data-auv-v3-recommendations','true');
    wrap.setAttribute('aria-label',ui('Aanbevolen sieraden','Rekommenderade smycken'));

    var head=document.createElement('div');head.className='auv-third__head';
    var block=document.createElement('div');
    var eyebrow=document.createElement('p');eyebrow.className='auv-third__eyebrow';eyebrow.textContent=ui('PAST BIJ JE KEUZE','PASSAR DITT VAL');
    var title=document.createElement('h3');title.className='auv-third__title';
    if(qty===1)title.textContent=ui('Voeg 1 toe voor 15% korting','Lägg till 1 för 15 % rabatt');
    else if(qty===2)title.textContent=ui('Voeg 1 toe voor 25% korting','Lägg till 1 för 25 % rabatt');
    else title.textContent=ui('Misschien ook iets voor jou','Kanske något mer för dig');
    block.appendChild(eyebrow);block.appendChild(title);head.appendChild(block);wrap.appendChild(head);

    var grid=document.createElement('div');grid.className='auv-third__grid';
    entries.forEach(function(entry){
      var p=entry.product,v=entry.variant;
      var item=document.createElement('article');item.className='auv-third__item';
      var src=(v.featured_image&&v.featured_image.src)||p.featured_image||(p.images&&p.images[0])||'';
      if(src){var img=document.createElement('img');img.className='auv-third__img';img.src=src;img.alt=p.title||'';img.loading='lazy';item.appendChild(img);}
      var meta=document.createElement('div');meta.className='auv-third__meta';
      var link=document.createElement('a');link.className='auv-third__name';link.href=rootPath()+'products/'+p.handle;link.textContent=p.title||'';meta.appendChild(link);
      var detail=document.createElement('span');detail.className='auv-third__variant';detail.textContent=(v.title&&v.title!=='Default Title'?v.title+' · ':'')+money(v.price);meta.appendChild(detail);item.appendChild(meta);
      var add=document.createElement('button');add.type='button';add.className='auv-third__add';add.setAttribute('data-auv-v3-rec-add',String(v.id));add.textContent=ui('Voeg toe','Lägg till');item.appendChild(add);
      grid.appendChild(item);
    });
    wrap.appendChild(grid);return wrap;
  }

  function renderRecommendations(cart){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer)return Promise.resolve();
    drawer.querySelectorAll('[data-auv-third-suggestions]').forEach(function(node){node.remove();});
    if(!cart||!Array.isArray(cart.items)||!cart.item_count)return Promise.resolve();
    var inCart=new Set(cart.items.map(function(item){return Number(item.product_id);}));
    var qty=eligibleQuantity(cart);
    return Promise.all(recHandles.map(loadProduct)).then(function(products){
      var entries=[];
      products.forEach(function(product){if(!product||inCart.has(Number(product.id)))return;var variant=firstAvailable(product);if(variant)entries.push({product:product,variant:variant});});
      entries=entries.slice(0,3);if(!entries.length)return;
      var items=drawer.querySelector('cart-drawer-items');
      var footer=drawer.querySelector('.drawer__footer');
      var panel=recommendationPanel(entries,qty);
      if(items&&items.parentNode)items.insertAdjacentElement('afterend',panel);
      else if(footer&&footer.parentNode)footer.parentNode.insertBefore(panel,footer);
    }).catch(function(){});
  }

  function scheduleRecommendations(cart){
    window.clearTimeout(recTimer);
    recTimer=window.setTimeout(function(){if(cart)renderRecommendations(cart);else cartJson().then(renderRecommendations).catch(function(){});},90);
  }

  document.addEventListener('click',function(event){
    var button=event.target.closest('[data-auv-v3-rec-add]');if(!button)return;
    event.preventDefault();if(button.disabled)return;
    var id=button.getAttribute('data-auv-v3-rec-add');var original=button.textContent;
    button.disabled=true;button.textContent=ui('Toevoegen…','Lägger till…');
    fetch(rootPath()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname+location.search})})
      .then(function(r){return r.json().then(function(data){if(!r.ok)throw data;return data;});})
      .then(function(data){button.textContent=ui('Toegevoegd ✓','Tillagt ✓');if(window.AUVENNECartDrawer&&typeof window.AUVENNECartDrawer.render==='function')return window.AUVENNECartDrawer.render(data,button);})
      .catch(function(){button.disabled=false;button.textContent=original;});
  });

  function hookDrawer(){
    var api=window.AUVENNECartDrawer;
    if(!api||api.__v3CommerceHooked||typeof api.render!=='function')return;
    api.__v3CommerceHooked=true;
    var previous=api.render;
    api.render=function(data,trigger){
      var result=previous.call(api,data,trigger);
      Promise.resolve(result).then(function(){window.setTimeout(function(){scheduleRecommendations();},60);window.setTimeout(function(){scheduleRecommendations();},280);});
      return result;
    };
  }

  function observeDrawer(){
    var drawer=document.querySelector('cart-drawer');if(!drawer||drawer.dataset.auvV3RecObserved==='1')return;
    drawer.dataset.auvV3RecObserved='1';
    new MutationObserver(function(){
      window.clearTimeout(drawerCheckTimer);
      drawerCheckTimer=window.setTimeout(function(){
        if(!drawer.querySelector('[data-auv-v3-recommendations]'))scheduleRecommendations();
      },140);
    }).observe(drawer,{childList:true,subtree:true});
  }

  document.addEventListener('auvenne:cart-synced',function(event){var cart=event&&event.detail&&event.detail.cart;scheduleRecommendations(cart);});

  function start(scope){initCardSwatches(scope||document);hookDrawer();observeDrawer();scheduleRecommendations();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){start(document);},{once:true});else start(document);
  document.addEventListener('shopify:section:load',function(event){start(event.target||document);});

  new MutationObserver(function(mutations){
    var needs=false;mutations.forEach(function(mutation){if(mutation.addedNodes&&mutation.addedNodes.length)needs=true;});
    if(needs)initCardSwatches(document);
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
